module.exports = __webpack_public_path__ + "media/images/river/shirt-carousel/shirt-5-0cc9fdd3ec20b4f31a81349697837f6f.jpg";